<template lang="pug">
  #app
    NavBar
    HomeBanner
    .container
      .row
        .col-md-9.pr-5
          router-view

        .col-md-3
          .row
            ApplyForServiceDogCard
          .row.mt-4
            HowYouCanHelpCard
      hr
    Footer

</template>

<script>
  import ApplyForServiceDogCard from './components/ApplyForServiceDogCard';
  import Footer from './components/Footer';
  import HomeBanner from './components/HomeBanner';
  import HowYouCanHelpCard from './components/HowYouCanHelpCard';
  import NavBar from './components/NavBar';
  export default {
    name: 'App',
    components: {
      ApplyForServiceDogCard,
      Footer,
      HomeBanner,
      HowYouCanHelpCard,
      NavBar
    }
  };
</script>

<style>
.router-link-active {
  color: #ffffff !important;
}
.dropdown-item.router-link-active {
  color: #000000 !important;
}
.top-margin {
  margin-top: 50px;
}
.card {
  margin-left: 10px;
  margin-right: 10px;
}
.card-header {
  background: linear-gradient(to right, rgb(4, 228, 4) , lightgreen)
}

.card-button {
  margin: 10px;
  background-color: green;
  border-color: green;
}

.navbar {
  box-shadow: 0 2px 5px rgba(0,0,0,0.35)
}
</style>



// WEBPACK FOOTER //
// src/App.vue